import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SummerNoteConfig } from 'src/app/common/summernote-config';

@Component({
    selector: 'app-reject-exsep',
    templateUrl: './reject-exsep.component.html',
    styleUrl: './reject-exsep.component.scss',
    standalone: false
})
export class RejectExsepComponent {
  note = '';
  summerNoteConfig = SummerNoteConfig.MAIN_CONFIG;

  constructor(
    public dialogRef: MatDialogRef<RejectExsepComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
